import { CommentIcon } from 'assets/icons';
import EmployeeAvatar from 'components/assign/EmployeeAvatar';
import { clockLabel, dayLabel } from 'helper/timeLabels';
import useText from 'hooks/useText';
import MentionText from './MentionText';

/**
 * The comments of a task, oldest first: who, when, and the text in a grey
 * bubble. With none yet, an invitation centred in the space left. `people`
 * colours the colleagues the comments name.
 */
const CommentThread = ({ comments, people }) => {
  const { text } = useText('comments');
  if (!comments) return null;
  if (!comments.length) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 px-6 py-6 text-center">
        <span className="flex size-10 items-center justify-center rounded-full bg-gray-100 text-gray-700">
          <CommentIcon wh={18} color="currentColor" />
        </span>
        <p className="text-sm font-medium text-gray-900">{text('emptyTitle')}</p>
        <p className="max-w-md text-sm text-gray-600">{text('emptyText')}</p>
      </div>
    );
  }
  return (
    <ol className="flex flex-col gap-4">
      {comments.map((comment) => {
        const at = new Date(comment.createdAt);
        return (
          <li key={comment.id} className="flex gap-3">
            <EmployeeAvatar employee={comment.author} size={32} />
            <div className="min-w-0 flex-1">
              <p className="text-sm">
                <span className="font-medium text-gray-900">
                  {comment.author ? `${comment.author.firstname} ${comment.author.lastname}`.trim() : text('someone')}
                </span>{' '}
                <span className="text-xs text-gray-500">
                  {text('at', { day: dayLabel(at), time: clockLabel(at) })}
                </span>
              </p>
              <p className="mt-1 whitespace-pre-wrap rounded-lg bg-gray-100 px-3 py-2 text-sm text-gray-900">
                <MentionText text={comment.body} people={people} />
              </p>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default CommentThread;
